import { type BreadcrumbSegment } from '@dittolive/anvil'
import { useAppContext } from 'context'
import { usePersonalNavSections } from 'scenes/userManagement/personalNavSections'

import PortalShell from './PortalShell'

/**
 * Shell for top-level pages that live outside a tenant context (feedback,
 * admin find pages, invitations, etc.). Uses the personal sidebar nav so the
 * user always has a way back to their databases and organizations.
 */
export default function PersonalShell({
  breadcrumbs = [],
  children,
}: {
  breadcrumbs?: BreadcrumbSegment[]
  children?: React.ReactNode
}) {
  const { isSuperAdmin } = useAppContext()
  const navSections = usePersonalNavSections({ isSuperAdmin })

  return (
    <PortalShell
      navSections={navSections}
      breadcrumbs={breadcrumbs}
      showTenantBreadcrumb
      tenantBreadcrumbName="Personal"
    >
      {children}
    </PortalShell>
  )
}
